import type { IconSvgObject } from './types';

const DollarSignIcon: IconSvgObject = [
  ["path", { d: "M17.5 8.63158C17.5 6.62699 15.0376 5.00195 12 5.00195C8.96243 5.00195 6.5 6.62699 6.5 8.63158C6.5 10.6362 8 11.7427 12 11.7427C16 11.7427 18 12.7797 18 15.3723C18 17.9649 15.5 19.002 12 19.002C8.5 19.002 6 17.502 6 15.502", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 3.00195V21.002", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default DollarSignIcon;
